import { default as setAppSettingsForTeam } from "../actions/setAppSettingsForTeam";
import { orchestrator } from "satcheljs";
import { setTeamDetails } from "sh-team-store";

export default orchestrator( setTeamDetails, async actionMessage => {
    const teamDetails = actionMessage.teamDetails;
    setAppSettingsForTeam(teamDetails.appSettings);
});